document.addEventListener("DOMContentLoaded", () => {
  const body = document.querySelector("body");
  const cartDrawer = document.querySelector("#cart_drawer_section");
  const cartDrawerBox = document.querySelector(".cart-drawer-box");
  const cartDrawerMain = document.querySelector(".cart-drawer");
  const cartCountHeader = document.querySelector(".cart-bubble__text-count");
  const cartDrawerOverlay = document.querySelector(".cart-drawer-overlay");

  function toggleCartDrawer(isOpen) {
    if (!cartDrawer) return;
    cartDrawer.classList.toggle("cart-drawer--active", isOpen);
    body.classList.toggle("scroll_locked", isOpen);
  }

  function updateCartItemCounts(count) {
    document
      .querySelectorAll("#CartCount span")
      .forEach((el) => (el.textContent = count));
  }

  async function fetchCartData() {
    return fetch("/cart.js").then((res) => res.json());
  }

  // ─────────────────────────────────────
  //  CART DRAWER PRODUCT RECOMMENDATIONS (VANILLA)
  // ─────────────────────────────────────
  async function updateCartRecommendations() {
    try {
      const { items } = await fetchCartData();
      if (!items.length) return;

      const productId = items[0].product_id;
      const recommendationsUrl =
        `/recommendations/products.json?product_id=${productId}&limit=4&intent=related`;

      const response = await fetch(recommendationsUrl);
      const data = await response.json();
      const products = data.products;

      if (!products || !products.length) return;

      const recommendationsContainer = document.querySelector(
        ".cart-drawer-recommendation-list"
      );
      if (!recommendationsContainer) return;

      recommendationsContainer.innerHTML = products
        .map((product) => createProductHTML(product))
        .join("");

      recommendationsContainer.classList.add(
        "cart-drawer-recommendation-list--ready"
      );

      attachAddToCartListenersRecommended();
      initCartDrawerSlider();
    } catch (error) {
      console.error("Failed to fetch recommendations:", error);
    }
  }

  function createProductHTML(product) {
    const tagsHTML = product.tags?.map(createTagHTML).join("") || "";

    return `
      <li class="cart-drawer-recommendation-item resource-list__item">
        <a class="cart-drawer-recommendation-item-image" href="${product.url}">
          <img src="${product.featured_image}" alt="${product.title}">
          <div class="product-multi-tags">${tagsHTML}</div>
        </a>
        <h3>${product.title}</h3>
        <p>
          <span>$${(product.price / 100).toFixed(2)}</span>
          ${
            product.compare_at_price
              ? `<span class="cart_drawer_recommend_compare_price">$${(
                  product.compare_at_price / 100
                ).toFixed(2)}</span>`
              : ""
          }
        </p>
        <form method="post" action="/cart/add" accept-charset="UTF-8" enctype="multipart/form-data" novalidate>
          <input type="hidden" name="id" value="${product.variants[0].id}">
          <input type="hidden" name="quantity" value="1">
          <button
            type="submit"
            name="add"
            aria-label="Add to cart"
            class="collection-btn btn product-form__cart-submitRecommended"
            data-add-to-cart
            tabindex="0"
          >
            <span data-add-to-cart-text>
              Add to cart
            </span>
            <span class="hide" data-loader>
              <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-spinner" viewBox="0 0 20 20">
                <path d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z" fill="#919EAB"></path>
              </svg>
            </span>
          </button>
        </form>
      </li>
    `;
  }

  function createTagHTML(tag) {
    const tagClassMap = {
      "BEST VALUE": "best-value",
      "BEST SELLER": "best-seller",
      "NEW ARRIVAL": "save new",
      "LIMITED QUANTITY": "best-value",
    };

    const tagClass = tagClassMap[tag] || "";

    if (tag.includes("Save")) {
      return `<span class="save">${tag.replace("Save ", "")} OFF</span>`;
    }

    if (tag === "Free Gift") {
      return `<span class="free-gift"><img src="/path/to/free-gift.svg" alt="Free Gift"></span>`;
    }

    return `<span class="best-tag ${tagClass}">${tag.trim()}</span>`;
  }

  // ─────────────────────────────────────
  //  UPDATE CART DRAWER
  // ─────────────────────────────────────
  async function updateCartDrawer() {
    if (!cartDrawer) return;

    try {
      const res = await fetch("/?section_id=cart-drawer-section");
      const html = await res.text();

      cartDrawer.innerHTML = new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(".cart-drawer").innerHTML;

      const cartCount = document
        .querySelector(".cart-drawer-header-right-items")
        ?.dataset.count;

      if (cartCountHeader) {
        cartCountHeader.textContent = cartCount || 0;
      }

      addCartDrawerListeners();

      setTimeout(() => {
  updateCartRecommendations();

  setTimeout(() => {
    initCartDrawerSlider();
  }, 200);

}, 100);


      const cartTotal = parseFloat(
        document
          .querySelector(".cart-total")
          ?.dataset.total.replace(/,/g, "") || 0
      );
      updateThresholds(cartTotal);

      const overlayEl = document.querySelector(".cart-drawer-overlay");
      overlayEl?.addEventListener("click", () => toggleCartDrawer(false));
    } catch (error) {
      console.error("Error updating cart drawer:", error);
    } finally {
      cartDrawerMain?.classList.remove("loader_active");
    }
  }

  // ─────────────────────────────────────
  //  CART DRAWER LISTENERS
  // ─────────────────────────────────────
  function addCartDrawerListeners() {
    document
      .querySelectorAll(".cart-drawer-quantity-selector button")
      .forEach((button) => {
        button.addEventListener("click", async () => {
          cartDrawerMain?.classList.add("loader_active");

          const rootItem = button.closest(".cart-drawer-item");
          const key = rootItem?.dataset.lineItemKey;
          const currentQuantity = Number(
            rootItem?.querySelector("input").value
          );
          const newQuantity = button.classList.contains(
            "cart-drawer-quantity-selector-plus"
          )
            ? currentQuantity + 1
            : currentQuantity - 1;

          if (newQuantity < 1 || !key) {
            cartDrawerMain?.classList.remove("loader_active");
            return;
          }

          await updateCartQuantity(key, newQuantity);
        });
      });

    document
      .querySelectorAll(".cart-drawer-header-right-close")
      .forEach((el) => {
        el.addEventListener("click", () => toggleCartDrawer(false));
      });

    cartDrawerBox?.addEventListener("click", (e) => e.stopPropagation());

    reattachDeleteButtonListeners();
  }

  async function updateCartQuantity(key, quantity) {
    try {
      const res = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: { [key]: quantity } }),
      });

      const cart = await res.json();

      updateCartItemCounts(cart.item_count);
      updateCartDrawer();
    } catch (error) {
      console.error("Error updating quantity:", error);
    }
  }

  function reattachDeleteButtonListeners() {
    document
      .querySelectorAll(".cart-drawer-item-delete")
      .forEach((deleteButton) => {
        deleteButton.addEventListener("click", async (e) => {
          e.preventDefault();
          cartDrawerMain?.classList.add("loader_active");

          const key = e.target.closest("button")?.dataset.lineItemKey;
          if (!key) return;

          await removeCartItem(key);
        });
      });
  }

  async function removeCartItem(key) {
    try {
      const res = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: { [key]: 0 } }),
      });

      const cart = await res.json();

      updateCartItemCounts(cart.item_count);
      updateCartDrawer();
    } catch (error) {
      console.error("Error during removeCartItem:", error);
    }
  }

  // ─────────────────────────────────────
  //  THRESHOLDS / PROGRESS BAR
  // ─────────────────────────────────────
  function updateThresholds(cartTotal) {
    const thresholdsWrapper = document.querySelector(
      ".cart-drawer-thresholds-wrapper"
    );
    if (!thresholdsWrapper) return;

    const giftElements = document.querySelectorAll(
      ".cart-drawer-thresholds-gift"
    );
    const messageElement = document.querySelector(
      ".cart-drawer-thresholds-message"
    );
    const progressBar = document.querySelector(
      ".cart-drawer-thresholds-bar"
    );

    if (!giftElements.length || !messageElement || !progressBar) return;

    let maxAmount = 0;
    const remainingOffers = [];

    giftElements.forEach((gift) => {
      const amount = parseFloat(gift.dataset.amount);
      maxAmount = Math.max(maxAmount, amount);

      if (cartTotal >= amount) {
        gift.classList.add("threshold-reached");
      } else {
        gift.classList.remove("threshold-reached");
        remainingOffers.push(
          `$${(amount - cartTotal).toFixed(2)} more for ${gift.dataset.message}`
        );
      }
    });

    messageElement.textContent = remainingOffers.length
      ? `Add ${remainingOffers.join(" plus ")}`
      : "Congratulations! You've unlocked all offers.";

    progressBar.style.width = `${Math.min(
      (cartTotal / maxAmount) * 100,
      100
    )}%`;
  }

  // ─────────────────────────────────────
  //  ADD TO CART (MAIN PRODUCTS)
  // ─────────────────────────────────────
  function attachAddToCartListeners() {
    document
      .querySelectorAll(".product-form__cart-submit")
      .forEach((button) => {
        button.addEventListener("click", async (e) => {
          e.preventDefault();
          console.log("button clicked page");

          const form = button.closest("form");
          if (!form) return;

          button.setAttribute("aria-disabled", "true");

          const addToCartText = button.querySelector(
            "[data-add-to-cart-text]"
          );
          const loader = button.querySelector("[data-loader]");

          addToCartText?.classList.add("hide");
          loader?.classList.remove("hide");

          cartDrawerBox?.classList.add("loader_active");

          try {
            await fetch("/cart/add", {
              method: "POST",
              body: new FormData(form),
            });

            const { item_count } = await fetchCartData();
            updateCartItemCounts(item_count);
            await updateCartDrawer();
            toggleCartDrawer(true);
          } catch (error) {
            console.error("Failed to add product to cart:", error);
          } finally {
            button.removeAttribute("aria-disabled");
            addToCartText?.classList.remove("hide");
            loader?.classList.add("hide");
            cartDrawerBox?.classList.remove("loader_active");
          }
        });
      });
  }

  // ─────────────────────────────────────
  //  ADD TO CART (RECOMMENDED PRODUCTS)
  // ─────────────────────────────────────
  function attachAddToCartListenersRecommended() {
    document
      .querySelectorAll(".product-form__cart-submitRecommended")
      .forEach((button) => {
        button.addEventListener("click", async (e) => {
          e.preventDefault();
          console.log("button clicked");

          const form = button.closest("form");
          if (!form) return;

          button.setAttribute("aria-disabled", "true");

          const addToCartText = button.querySelector(
            "[data-add-to-cart-text]"
          );
          const loader = button.querySelector("[data-loader]");

          addToCartText?.classList.add("hide");
          loader?.classList.remove("hide");

          cartDrawerBox?.classList.add("loader_active");

          try {
            await fetch("/cart/add", {
              method: "POST",
              body: new FormData(form),
            });

            const { item_count } = await fetchCartData();
            updateCartItemCounts(item_count);
            await updateCartDrawer();
            toggleCartDrawer(true);
          } catch (error) {
            console.error("Failed to add product to cart:", error);
          } finally {
            button.removeAttribute("aria-disabled");
            addToCartText?.classList.remove("hide");
            loader?.classList.add("hide");
            cartDrawerBox?.classList.remove("loader_active");
          }
        });
      });
  }

  // ─────────────────────────────────────
  //  GLOBAL EVENT HOOKS
  // ─────────────────────────────────────
  document.querySelectorAll('a[href="/cart"]').forEach((a) => {
    a.addEventListener("click", async (e) => {
      e.preventDefault();
      // Sync + open from header cart link click
      cartDrawerMain?.classList.add("loader_active");
      await updateCartDrawer();
      toggleCartDrawer(true);
      cartDrawerMain?.classList.remove("loader_active");
    });
  });

  cartDrawerOverlay?.addEventListener("click", () => {
    toggleCartDrawer(false);
  });

  // 👉 THIS IS THE IMPORTANT PART: inside DOMContentLoaded,
  //    so it has access to cartDrawerMain, toggleCartDrawer, updateCartDrawer, etc.
  window.addEventListener("custom:open-cart-drawer", async () => {
    try {
      cartDrawerMain?.classList.add("loader_active");

      // Optional: sync count before updating section
      try {
        const { item_count } = await fetchCartData();
        updateCartItemCounts(item_count);
      } catch (err) {
        console.warn(
          "Failed to sync cart count before opening drawer",
          err
        );
      }

      await updateCartDrawer();
      toggleCartDrawer(true);
    } catch (error) {
      console.error("Error opening cart drawer from product-form:", error);
    } finally {
      cartDrawerMain?.classList.remove("loader_active");
    }
  });

  // Initial bindings
  addCartDrawerListeners();
  attachAddToCartListeners();

  // Populate recommendations once on load
  updateCartRecommendations();

  // In case any recommended buttons exist on load
  setTimeout(() => {
    attachAddToCartListenersRecommended();
  }, 1000);

  // Initial thresholds
  const initialCartTotal = parseFloat(
    document
      .querySelector(".cart-total")
      ?.dataset.total.replace(/,/g, "") || 0
  );
  updateThresholds(initialCartTotal);
});




function initCartDrawerSlider() {
  if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
    console.warn('jQuery or Slick not available — slider init skipped.');
    return;
  }
  const $slider = jQuery('.cart-drawer-recommendation-list--ready');
  if (!$slider.length) return;

  if ($slider.hasClass('slick-initialized')) {
    try {
      $slider.slick('unslick');
    } catch (err) {
    }
  }
  const imgs = $slider.find('img').get();
  let imagesLoaded = 0;
  if (imgs.length === 0) {
    doInit();
  } else {
    imgs.forEach(img => {
      if (img.complete && img.naturalWidth !== 0) {
        imagesLoaded++;
        if (imagesLoaded === imgs.length) doInit();
      } else {
        img.addEventListener('load', () => {
          imagesLoaded++;
          if (imagesLoaded === imgs.length) doInit();
        });
        img.addEventListener('error', () => {
          imagesLoaded++;
          if (imagesLoaded === imgs.length) doInit();
        });
      }
    });
  }
  function doInit() {
    $slider.slick({
      infinite: false,
      slidesToShow: 2.5,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      swipeToSlide: true,
      prevArrow: '<button type="button" class="slick-prev">‹</button>',
      nextArrow: '<button type="button" class="slick-next">›</button>',
      responsive: [
        { breakpoint: 768, settings: { slidesToShow: 2.5 } }
      ]
    });
  }
}

